import { SModal } from "@superwall-me/sui"
import { FC } from "react"

interface LocalizationModalProps {
  isOpen: boolean
  onClose: () => void
}

export const LocalizationModal: FC<LocalizationModalProps> = ({ isOpen, onClose }) => {
  return (
    <SModal isOpen={isOpen} onClose={onClose}>
      <SModal.Content onClose={onClose} maxWidth="sm" className="!max-w-xl">
        <SModal.Title>Localization</SModal.Title>
        <div className="mt-4">
          <p className="text-white/70">
            Localization is now managed directly in the paywall editor. You can configure
            localization settings for each paywall individually by editing the paywall and accessing
            the localization options.
          </p>
        </div>
        <SModal.ActionSection>
          <SModal.Action onClick={onClose}>Got it</SModal.Action>
        </SModal.ActionSection>
      </SModal.Content>
    </SModal>
  )
}
